/**
 * The one grading scale of qualification tests, the one the server works
 * with: each item out of 10, a weighted total out of 10 (phonemes 30 %,
 * phrases 30 %, translations 40 %), and 5 as the pass mark. The contracts
 * module only offers a contract to a VALIDATED test scoring 5 or more
 * (tests.service getEligibleUserIds / markUserLatestEligibleSubmissionValidated).
 */
export const TEST_PASS_MARK = 5;
export const TEST_MAX_SCORE = 10;

/** The total sent to the server, rounded like the grading screen does. */
export const roundTestScore = (total: number) => Math.round(total * 100) / 100;

export function testOutcome(total: number): "pass" | "reject" {
  return roundTestScore(total) < TEST_PASS_MARK ? "reject" : "pass";
}

/** "6,5" in French, "6.5" in English. */
export function formatTestScore(total: number, lang: string): string {
  return roundTestScore(total).toLocaleString(lang === "en" ? "en-US" : "fr-FR", { maximumFractionDigits: 2 });
}
